import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxxl-12" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white calendar-card" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "header-left-side justify-content-center justify-content-md-start d-flex align-items-center col-12 col-md-12 col-sm-12 col-lg-4 col-xl-4 col-xxl-4 mb-15" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Selecione um usuário", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "*" }, "Todos os usuários", -1)
const _hoisted_8 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreateScheduleModal = _resolveComponent("CreateScheduleModal")!
  const _component_UpdateScheduleModal = _resolveComponent("UpdateScheduleModal")!
  const _component_FullCalendar = _resolveComponent("FullCalendar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CreateScheduleModal, { date: _ctx.selectedDate }, null, 8, ["date"]),
    _createVNode(_component_UpdateScheduleModal),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.getUsers.length)
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 0,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedUser) = $event)),
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onOperationChange && _ctx.onOperationChange(...args))),
                    class: "form-select shadow-none text-black fs-md-15"
                  }, [
                    _hoisted_6,
                    _hoisted_7,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUsers, (user) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: user.id,
                        value: user.id
                      }, _toDisplayString(user.name), 9, _hoisted_8))
                    }), 128))
                  ], 544)), [
                    [_vModelSelect, _ctx.selectedUser]
                  ])
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_FullCalendar, { options: _ctx.calendarOptions }, null, 8, ["options"])
          ])
        ])
      ])
    ])
  ], 64))
}